import { IAppState, TActions } from '../../../common/state';
import { jq } from '../../../json_query';

export function specialOffersReducer(state: IAppState, action: TActions): IAppState {
  switch (action.type) {
    case 'filters/tags/TAG_REMOVED':
      if (action.tag.type === 'advanced-black-friday') {
        return {
          ...state,
          filters: {
            ...state.filters,
            jsonQuery: jq(state.filters.jsonQuery).setBlackFriday(false),
          },
        };
      }

      if (action.tag.type === 'advanced-developer-promo') {
        return {
          ...state,
          filters: {
            ...state.filters,
            jsonQuery: jq(state.filters.jsonQuery).setPromo(false),
          },
        };
      }

      return state;

    default:
      return state;
  }
}
